import { db } from './FirebaseApp';

export const usersCollectionRef = db.collection("users");

export const roundsCollectionRef = db.collection("rounds");